import { dummy } from "../dummy";

export default () => dummy;
